export interface AriaItem {
  ariaHidden?: boolean;
  ariaLabel?: string;
}
